import { render, staticRenderFns } from "./FeedItemCard.vue?vue&type=template&id=2d0d035c&scoped=true"
import script from "./FeedItemCard.vue?vue&type=script&lang=js"
export * from "./FeedItemCard.vue?vue&type=script&lang=js"
import style0 from "./FeedItemCard.vue?vue&type=style&index=0&id=2d0d035c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d035c",
  null
  
)

export default component.exports